import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useTheme } from "@emotion/react";
import {useRef} from 'react';
import { pdfUrlCheck } from "@/helpers/pdfUrlCheck";

const ButtonPill = ({ children, to, buttonTheme, noBorder, active, type, target, className, onClick, stretch, tagOverride }) => {
  const theme = useTheme();
  const Tag = tagOverride || createTagComponent(to);
  const pdfItem = useRef(false)

  const buttonClass = buttonTheme ? buttonTheme : 'dark';

  let bonusProps = {};
  if (type) bonusProps.type = type;
  // check if PDF
  let checkedUrl = pdfUrlCheck(to, children);
  to = checkedUrl.href;

  //if pdf add target and flag
  if(checkedUrl.pdf){
    bonusProps.target = checkedUrl.target;
    pdfItem.current = true;
  }
  // target overrride option
  if (target) bonusProps.target = target;
  if (onClick) bonusProps.onClick = onClick;

  // if pdf track as file download
  const trackEvent = () => {
    if(pdfItem.current){
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
       'event': 'file_download',
        link_text: JSON.stringify(children),
          link_url: to
      });
    }
}

  // Return the component, with `href` if Tag is 'a', for external or mailto links
  return children ? (
    <Tag
      css={{ ...theme.typography.button, width: stretch ? "100%" : "auto" }}
      className={`pill pill-${buttonClass} ${noBorder ? "no-border" : ""} ${
        active ? "active" : ""
      } ${className}`}
      to={Tag === Link ? to : null}
      href={Tag === "a" ? to : null}
      onClick={trackEvent}
      {...bonusProps}
    >
      {children}
    </Tag>
  ) : null;
};

// Function to determine the tag type (Link, 'a' for external/mailto, or 'button')
const createTagComponent = (path) => {
  if (path === undefined) {
    return "button";
  }
  const absolutePathPattern = /^https?:\/\//i;
  const mailtoPattern = /^mailto:/i;

  if (mailtoPattern.test(path)) {
    return "a"; // Use <a> for mailto links
  }
  if (absolutePathPattern.test(path)) {
    return "a";
  }

  return Link;
}


ButtonPill.propTypes = {
  to: PropTypes.string,
  children: PropTypes.node,
  type: PropTypes.string,
  target: PropTypes.string,
  className: PropTypes.string,
  buttonTheme: PropTypes.string,
  noBorder: PropTypes.bool,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  stretch: PropTypes.bool,
  tagOverride: PropTypes.string
};

export default ButtonPill;
